import API from './apiClient';


interface LoginPayload {
  email: string;
  password: string;
}

interface LoginResponse {
  access: string;
  refresh: string;
}

interface SignUpResponse {
  id: string;
  email: string;
  first_name: string | null;
  last_name: string | null;
  phone_number: string | null;
  account_type: 'PER' | 'COM';
}

interface LogoutPayload {
  refresh: string;
}

interface UserProfile {
  id: string;
  email: string;
  // username: string | null;
  first_name: string | null;
  last_name: string | null;
  phone_number: string | null;
  account_type: 'PER' | 'COM';
  user_type: 'REG' | 'EMR';
  emergency_contacts: EmergencyContact[];
}

interface EmergencyContact {
  id: string;
  email: string;
  first_name: string | null;
  is_active: boolean;
  has_accepted: boolean;
  created_at: string;
  last_invitation_sent: string;
}

interface AddEmergencyContactPayload {
  name: string;
  email: string;
}

interface AddEmergencyContactResponse {
  detail: string;
  emergency_contact: EmergencyContact;
}
interface VerifyQRPayload { qr_data: string }
interface VerifyQRResponse { mac_address: string }

interface SignUpWizardPayload {
  email: string; password: string;
  name: string;
  phone_number: string;
  mac_address: string;
  registration_no?: string;
  brand: string;
  model: string;
  manufacture_year: number;
  color?: string;
}
interface VerifyOtpPayload { email: string; otp: string }
interface VerifyOtpResponse { access: string; refresh: string }

interface ForgotPasswordPayload { email: string }
interface ForgotPasswordResponse { detail: string }

interface ResetPasswordPayload {
  email: string;
  token: string;
  new_password: string;
  confirm_password: string
}
interface ResetPasswordResponse { detail: string }

interface EmergencyContactLoginPayload {
  email: string;
  access_code: string;
}

interface EmergencyContactLoginResponse {
  access: string;
  refresh: string;
  user: UserProfile;
}

const URLS = {
  LOGIN: '/auth/login',
  SIGNUP: '/auth/signup',
  LOGOUT: '/auth/logout',
  PROFILE: '/auth/me',
  VERIFY_QR: '/auth/verify-qr',
  VERIFY_OTP: '/auth/verify-otp',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  EMERGENCY_CONTACTS: '/auth/emergency-contacts',
  EMERGENCY_CONTACT_LOGIN: '/auth/emergency-contact-login',
}

const loginAPI = (data: LoginPayload) =>
  API.post<LoginResponse>(URLS.LOGIN, data);

const signUpAPI = (data: SignUpWizardPayload) =>
  API.post<SignUpResponse>(URLS.SIGNUP, data);

const logoutAPI = (data: LogoutPayload) =>
  API.post<void>(URLS.LOGOUT, data);

const fetchProfileAPI = () =>
  API.get<UserProfile>(URLS.PROFILE);

const verifyQRAPI  = (data: VerifyQRPayload) =>
  API.post<VerifyQRResponse>(URLS.VERIFY_QR, data);

const verifyOtpAPI = (data: VerifyOtpPayload) =>
  API.post<VerifyOtpResponse>(URLS.VERIFY_OTP, data);

const forgotPasswordAPI = (data: ForgotPasswordPayload) =>
  API.post<ForgotPasswordResponse>(URLS.FORGOT_PASSWORD, data);

const resetPasswordAPI = (data: ResetPasswordPayload) =>
  API.post<ResetPasswordResponse>(URLS.RESET_PASSWORD, data);

const fetchEmergencyContactsAPI = () =>
  API.get<EmergencyContact[]>(URLS.EMERGENCY_CONTACTS);

const addEmergencyContactAPI = (data: AddEmergencyContactPayload) =>
  API.post<AddEmergencyContactResponse>(URLS.EMERGENCY_CONTACTS, data);

const deleteEmergencyContactAPI = (id: string) =>
  API.delete(`${URLS.EMERGENCY_CONTACTS}/${id}`);

const resendEmergencyContactInvitationAPI = (id: string) =>
  API.post(`${URLS.EMERGENCY_CONTACTS}/${id}/resend-invitation`, {});

const emergencyContactLoginAPI = (data: EmergencyContactLoginPayload) =>
  API.post<EmergencyContactLoginResponse>(URLS.EMERGENCY_CONTACT_LOGIN, data);

export {
  type LoginPayload,
  type LoginResponse,
  type SignUpResponse,
  type LogoutPayload,
  type UserProfile,
  type EmergencyContact,
  type AddEmergencyContactPayload,
  type AddEmergencyContactResponse,
  type ForgotPasswordPayload,
  type ForgotPasswordResponse,
  type ResetPasswordPayload,
  type ResetPasswordResponse,
  type EmergencyContactLoginPayload,
  type EmergencyContactLoginResponse,

  loginAPI,
  signUpAPI,
  logoutAPI,
  fetchProfileAPI,
  verifyQRAPI,
  verifyOtpAPI,
  forgotPasswordAPI,
  resetPasswordAPI,
  fetchEmergencyContactsAPI,
  addEmergencyContactAPI,
  deleteEmergencyContactAPI,
  resendEmergencyContactInvitationAPI,
  emergencyContactLoginAPI,
}
